import React, { useEffect } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import DeedsySpinner from 'src/components/DeedsySpinner/DeedsySpinner';
import { getQueryParam } from 'src/utilities/queryParams';
import { compose } from 'ramda';
import { authenticateMagicToken } from 'src/services/account';
import { loginMagicLink } from '../Login/loginAccounts';
import { isNotEmpty } from 'src/utilities/hasValue';
import { unAuthenticatedUser } from 'src/utilities/storage';

const MagicLinkInviteLanding = (props: any) => {
  const { match } = props;
  const { token } = match.params;
  const email = getQueryParam(location.search, 'email');
  const advisorUsername = getQueryParam(location.search, 'advisor');
  const loanType = getQueryParam(location.search, 'type_of_loan');
  const propertyType = getQueryParam(location.search, 'loan_product_type');
  const history = useHistory();

  const authenticateMagicLinkUser = async () => {
    /**
     * When User Click Invite link from email we are checking if the client have pwdless signup
     * we will save invite params details in session storage after that we are redirect to getstarted page.
     * If client haven't pwdless process we are moving to generate password after the authentication
     */
    // in case we need to enable this configurable then have to use site settings flag
    try {
      const userResp = await authenticateMagicToken({ email, password: token });
      loginMagicLink(userResp, history, advisorUsername, { loanType, propertyType });
    } catch (error) {
      history.push('/login');
    } finally {
      if (advisorUsername) {
        unAuthenticatedUser.advisorUsername.set(advisorUsername);
      }
    }
  };
  useEffect(() => {
    if (isNotEmpty(loanType) && isNotEmpty(propertyType))
      authenticateMagicLinkUser();
  }, [loanType, propertyType]);
  return <DeedsySpinner />;
};
export default compose(withRouter)(MagicLinkInviteLanding);